export class MeetingStarterViewModel
{
    opened: boolean = false;

    surveyStarted: boolean | null = null;
    autoRevealEnabled: boolean | null = null;
    namesRevealed: boolean | null = null;

    show(surveyStarted: boolean, autoRevealEnabled: boolean, namesRevealed: boolean)
    {
        this.surveyStarted = surveyStarted;
        this.autoRevealEnabled = autoRevealEnabled;
        this.namesRevealed = namesRevealed;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.surveyStarted = null;
        this.autoRevealEnabled = null;
        this.namesRevealed = null;
    }
}